var exports = {
  "kL": "xa9f3555f--db802c--container",
  "R_": "xa9f3555f--db802c--heading",
  "XI": "xa9f3555f--db802c--action",
  "AS": "xa9f3555f--db802c--item",
};

module.exports = exports;
